import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default function createRouter() {
  const routes = [
    {
      path: "/",
      name: "home",
      component: () => import("./views/home/index.vue"),
    },
    {
      path: "/catalog/:id?",
      name: "catalog",
      component: () => import("./views/catalog/index.vue"),
    },
    {
      path: "/shop",
      name: "shop",
      component: () => import("./views/shop/list/index.vue"),
    },
    {
      path: "/shop/:id",
      name: "shop_item",
      component: () => import("./views/shop/open/index.vue"),
    },
    {
      path: "/child",
      name: "child",
      component: () => import("./views/child/index.vue"),
    },
    {
      path: "/product/:id/:link?",
      name: "product",
      component: () => import("./views/product/index.vue"),
    },
    {
      path: "/user/:link?",
      name: "user",
      component: () => import("./views/user/index.vue"),
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/cart",
      name: "cart",
      component: () => import("./views/cart/index.vue"),
    },
    {
      path: "/download-pdf",
      name: "download-pdf",
      component: () => import("./views/download-pdf/index.vue"),
      meta: {
        onlyContent: true,
      },
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/about/index.vue"),
    },
    {
      path: "/shares",
      name: "shares",
      component: () => import("./views/shares/list/index.vue"),
    },
    {
      path: "/news",
      name: "news",
      component: () => import("./views/news/list/index.vue"),
    },
    {
      path: "/news/:id",
      name: "news_item",
      component: () => import("./views/news/open/index.vue"),
    },
    {
      path: "/brands",
      name: "brands",
      component: () => import("./views/brands/list/index.vue"),
    },
    {
      path: "/school",
      name: "school",
      component: () => import("./views/school/index.vue"),
    },
    {
      path: "/static/:id",
      name: "static",
      component: () => import("./views/static/index.vue"),
    },
    {
      path: "/thank-you",
      name: "thank-you",
      component: () => import("./views/ThankYou.vue"),
      // meta: {
      //   authRequired: true,
      // },
    },
    {
      path: "/documents",
      name: "documents",
      component: () => import("./views/documents/index.vue"),
    },
    {
      path: "*",
      name: "notfound",
      component: () => import("./views/PageNotFound.vue"),
    },
  ];
  return new Router({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      if (to.hash) {
        return {
          selector: to.hash,
          behavior: "smooth",
        };
      }
      return { x: 0, y: 0 };
    },
    fallback: true,
    routes,
  });
}
